export enum ROUTES {
  // Public routes
  LOGIN = "/",
  ACCOUNT_REGISTER = "/accountregister/:id",
  FORGOT_PASSWORD = "/forgotpassword",
  RESET_PASSWORD = "/resetpassword",
  INVALID_PAGE = "/invalidpage",
  PAY_LINK_EXPIRED = "/paylinkexpired",
  ACTION = "/action",
  TERMS = "/terms",
  PUBLIC_CLASS_BOOKING = "/public/class-booking/:branchId/:classId?",

  // Private / App routes
  HOME = "/home",
  CHALLENGE_CREATE = "/challenge-create/:challengeId?",
  CHALLENGES = "/challenges",
  CHALLENGE_VIEW = "/challenge-view/:challengeId",
  TRAINERS = "/trainers",
  TRAINER_DETAILS = "/trainer-details/:trainerId",
  MEMBER_REPORT = "/member-report",
  MEMBERS = "/members",
  ADD_MEMBER_PAGE = "/addmemberpage",
  EDIT_MEMBER_PAGE = "/editmember/:memberId/:branchId",
  ADD_QUICK_MEMBER_PAGE = "/addquickmemberpage",

  PROFILE = "/profile",
  BRANCHES = "/branches",
  ADD_BRANCH_PAGE = "/addbranchpage",
  UPDATE_BRANCH_PAGE = "/updatebranchpage/:branchId",
  UPDATE_BRANCH_IMAGE_PAGE = "/updatebranchimagepage/:branchId",
  BRANCH_DETAILS = "/branchdetails/:branchid",
  MEMBER_DETAILS = "/membersdetails/:memberid/:branchId",
  MEMBER_HISTORY = "/membersdetails/:memberid/:branchId/memberhistory",
  PACKAGE_PAGE = "/packagepage",
  PACKAGE_VIEW_PAGE = "/packageviewpage/:companyId/:packageId",
  USERS = "/users",
  USER_DETAILS = "/usersdetails/:adminDocId",
  COMPANY_PROFILE = "/companyprofile",
  LEAD_INTEGRATION = "/leadintegration",
  META_INTEGRATION = "/meta-integration",
  GMB_INTEGRATION = "/gmb-integration",
  ROUTINE_PLAN = "/routineplan",
  ROUTINE_PLAN_CREATE = "/routineplancreate",
  ROUTINE_PLAN_UPDATE = "/routineplanupdate/:id",
  ROUTINE_DETAIL_PAGE = "/routinedetailpage/:id",
  CLASSES_PACKAGES = "/classes-packages",
  CLASSES_PACKAGES_CREATE = "/classes-packages-create",
  CLASSES_PACKAGES_EDIT = "/classes-packages-edit/:packageId",
  CLASSES = "/classes",
  CLASSES_CREATE = "/classes-create/:classId?",
  CLASSES_IMPORT = "/classes/import",
  CLASSES_DETAILS = "/classes-details/:classId",
  CLASSES_SCHEDULE_CREATE = "/classes-schedule-create/:classId?",
  CLASSES_SCHEDULE_EDIT = "/classes-schedule-edit/:classId/:scheduleId",
  CLASSES_SCHEDULE_DETAILS = "/classes-schedule-details/:classId/:scheduleId",
  CLASSES_INSTANCES = "/classes-instances",
  CLASSES_INSTANCES_DETAILS = "/classes-instances-details/:instanceId",
  CLASS_REPORT = "/class-report",
  EXPENSE = "/expense",
  ADD_TRANSACTION = "/addtransaction",
  EXPENSE_VIEW_PAGE = "/expenseviewpage/:transactionId",
  EXPENSE_EDIT_PAGE = "/expenseeditpage/:transactionId",
  RECURRING_EXPENSE_VIEW_PAGE = "/recurringexpenseviewpage/:transactionId",
  ADD_PAYMENT_RECEIVED = "/addpaymentreceived",
  ENQUIRY = "/enquiry",
  ENQUIRY_VIEW = "/enquiryview/:branchId/:enquiryId",
  ENQUIRY_ADD = "/enquiry-add",
  ENQUIRY_EDIT = "/enquiry-edit/:branchId/:enquiryId",
  ENQUIRY_MANAGEMENT = "/enquirymanagement",
  ENQUIRY_SETTINGS = "/enquirysettings",
  BIOMETRIC_INFO = "/biometricinfo",
  ADD_BIODEVICE = "/addbiodevice",
  EDIT_BIODEVICE = "/editbiodevice/:serial_number",
  ATTENDANCE_REPORT = "/attendance-report",
  EXPENSE_REPORT = "/expense-report",
  PAYROLL_REPORT = "/payroll-report",
  PRODUCT_SALES_REPORT = "/product-sale-report",
  PACKAGE_SALES_REPORT = "/package-sale-report",
  EQUIPMENT = "/equipment",
  ADD_EQUIPMENT = "/equipment-add",
  EQUIPMENT_IMPORT = "/equipment/import",
  UPDATE_EQUIPMENT = "/updateequipment/:equipmentDocId/:branchId",
  SETTING_OVERVIEW = "/settingoverview",
  MONTH_VIEW = "/month-view",
  CHAT = "/chat",
  ADD_NEW_STAFF = "/addnewstaff",
  COMPANY_SETTING = "/companysetting",
  MANAGE_SUBSCRIPTION = "/managesubscription",
  BUSINESS_HOURS = "/businesshours",
  ATTENDANCE_SETTINGS = "/attendancesettings",
  MEMBER_ATTENDANCE_SETTINGS = "/memberattendancesettings",
  PAYROLL = "/payroll",
  HOLIDAY = "/holiday",
  BANKING = "/banking",
  PAYMENT = "/payment",
  EDIT_PAYMENT_METHOD = "/editpaymentmethod/:companyID/:selectedUPIDataId",
  ADD_PAYMENT_METHOD = "/addpaymentmethod",
  CASHFREE_CONNECT = "/cashfreeconnect",
  RAZORPAY_CONNECT = "/razorpayconnect",
  PACKAGE_CREATE = "/packagecreate",
  PACKAGE_IMPORT = "/packages/import",
  ADD_BANKING_PAGE = "/addbankingpage",
  PREFIX_PAGE = "/prefixpage",
  EMAIL_TEMPLATE_MANAGE = "/emailtemplatemanage",
  CREATE_EMAIL_TEMPLATE = "/createemailtemplate",
  PAYMENT_RECEIVED_PAGE = "/paymentreceivedpage",
  PAYMENT_RECEIVED_VIEW = "/paymentreceivedviewpage/:transactionId",
  PAYMENT_RECEIVED_EDIT = "/paymentreceivededit/:transactionId",
  // RECURRING_PAYMENTS = "/recurring-payments",

  INVOICE_PAGE = "/invoicepage",
  INVOICE_DETAILS_PAGE = "/invoicedetailspage/:invoiceid/:branchid",
  ADD_INVOICE_PAGE = "/invoiceaddpage",
  BILLS_PAGE = "/bills",
  BILL_DETAILS = "/bills/:billid",
  MEMBER_IMPORT_PAGE = "/memberimportpage",
  STAFF_IMPORT_PAGE = "/staffimportpage",
  SUBSCRIPTION_PAGE = "/subscriptionpage",
  STAFF_LOCATION_ACCESS_CONTROL_PAGE = "/stafflocationaccesscontrolpage",
  ADD_GEO_RESTRICTION = "/addgeorestriction",
  EDIT_GEO_RESTRICTION = "/editgeorestriction/:branchId",
  ADD_IP_RESTRICTION = "/addiprestriction",
  EDIT_IP_RESTRICTION = "/editiprestriction/:branchId",
  NEW_SUBSCRIPTION_PAGE = "/newsubscriptionpage",
  EDIT_STAFF_SALARY = "/editstaffsalary/:adminDocId",
  EDIT_STAFF_DOCUMENT = "/editstaffdocuments/:adminDocId",
  EXERCISE_CREATE_PAGE = "/exercisecreatepage",

  // Company / Registration
  COMPANY_REGISTRATION = "/company/registration/:companyId?",
  COMPANY_CLAIM = "/company/claim",
  COMPANY_CLAIMED = "/company/claimed",
  // COMPANY_CREATE_NEW = "/company/create/new",
  COMPANY_REGISTRATION_MODAL = "/create/company/:companyId?",
  COMPANY_REGISTER_WIZARD = "/create/companywizard/:companyId?",
  CHOOSE_COMPANY_TYPE = "/choose/companytype/:companyId?",
  MAP_BRANCHES_TO_COMPANY = "/company/mapbranches",

  // WhatsApp
  WHATSAPP = "/whatsapp",
  WHATSAPP_CHAT = "/whatsapp/chat",
  WHATSAPP_CONFIG = "/whatsapp/config",
  WHATSAPP_REGISTRATION = "/whatsapp/registration",
  WHATSAPP_MAPPING = "/whatsapp/mapping",
  WHATSAPP_LOGS = "/whatsapp/logs",

  // SMS
  SMS = "/sms",
  SMS_CONFIG = "/sms/config",
  SMS_REGISTRATION = "/sms/registration",
  SMS_MAPPING = "/sms/mapping",

  // Email
  EMAIL = "/email",
  EMAIL_SMTP_CONFIG = "/email/smtp-config",

  // Payment pages
  PAYMENT_PAGE = "/paymentpage",
  PAYMENT_SUCCESS_PAGE = "/paymentsuccesspage",
  MEMBER_PAYMENT_SUCCESS_PAGE = "/membersuccesspage",
  PAYMENT_FAILED_PAGE = "/paymentfailedpage",
  //Payroll pages
  PAYROLL_MAIN_PAGE = "/payrollmainpage",
  PAYROLL_EMPLOYEES_PAGE = "/payrollemployeespage/:payrollId",
  PAYROLL_MY_REPORT = "/payrollmyreport",

  //Leave Management pages
  APPLY_LEAVE = "/apply-leave",
  LEAVE_APPROVALS = "/leave-approvals",

  // Loan Management
  LOAN_TYPES = "/loan-types",
  LOAN_LIST = "/loans",
  LOAN_DETAILS = "/loans/:loanId",
  GRANT_LOAN = "/grant-loan",

  //form builder
  FORM_BUILDER_PAGE = "/formbuilder",
  CREATE_FORM_PAGE = "/createform",
  EDIT_FORM_PAGE = "/editform/:formId",
  
  // Chatbot Builder
  CHATBOT_BUILDER = "/chatbotbuilder",

  // Flow Builder
  FLOWS_LIST = "/flows",
  FLOW_BUILDER = "/flowbuilder/:flowId?",
  FLOW_BUILDER_ALT = "/flow-builder/:flowId?",

  // Landing Pages
  LANDING_PAGES_LIST = "/landingpages",
  LANDING_PAGE_BUILDER = "/landingpagebuilder/:pageId?",

  // Playground / Misc
  PLAYGROUND = "/playground",
  CLASS_PAGE = "/class/:classId",
  CLASS_BOOKING_PAGE = "/classBooking/:classId",
  ALL_PRODUCTS_PAGE = "/products",
  ADD_PRODUCT_PAGE = "/addproduct",
  EDIT_PRODUCT_PAGE = "/editproduct/:productId",
  PRODUCT_DETAILS_PAGE = "/productdetails/:productId",
  PRODUCT_IMPORT_PAGE = "/productimportpage",
  PURCHASE_ORDER_PAGE = "/purchaseorder",
  CREATE_PURCHASE_ORDER = "/purchaseorder/create",
  EDIT_PURCHASE_ORDER = "/purchaseorder/edit/:poid",
  PURCHASE_ORDER_DETAILS = "/purchaseorder/:poid",
  VENDOR_PAGE = "/vendorpage",
  ASSIGN_MEMBERS_PAGE = "/classes/:classId/assign-members",
  COMMUNICATION_PAGE = "/communication",
  ADD_MEMBER_QUICK_PAGE = "/addmember/quick",
  CUSTOMIZE_QUICK_MEMBER_PAGE = "/customize/quickmember",
  ADD_EXERCISE_PAGE = "/addexcercise",
  CERTIFICATE_UPLOAD_PAGE = "/certificateupload/:adminDocId",
  STAFF_SALARY_PAGE = "/staffsalary/:adminDocId",
  INVENTORY_PAGE = "/inventory",
  INVENTORY_DETAILS_PAGE = "/inventorydetails/:id",
  ADD_INVENTORY_PAGE = "/addinventory",
  EDIT_INVENTORY_PAGE = "/editinventory/:id",
  ADJUST_STOCK_PAGE = "/adjuststock",

  USER_GUIDE = "/user-guide",
  ROOMS = "/rooms",
  
  // Diagnostics
  API_HEALTH = "/api-health",

  MEMBER_ROUTINE_GENERATOR = "/member-routine-generator",

  REWARDS_PAGE = "/rewards",
  REFFERAL_SETTINGS='/refferal-settings',

  // Fallback
  NOT_FOUND = "*",
  RECURRING_PAYMENTS = "/recurring-payments",
}
